<svg
  height="99.199997"
  width="99.25"
  id="el__9SDZEX4H"
  viewBox="0 0 99.25 99.199997"
  y="0px"
  x="0px"
  preserveAspectRatio="xMidYMid meet"
  version="1.1"
  [ngStyle]="{
    width: this.size + 'px',
    height: this.size + 'px'
  }"
  [ngClass]="'color-' + color"
>
  <style id="style28">
    @-webkit-keyframes kf_el_ISgU0t5CVH_an_kLxXqVD9M {
      0% {
        -webkit-transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
        transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
      }
      100% {
        -webkit-transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(360deg) translate(-100.0250015258789px, -100.0250015258789px);
        transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(360deg) translate(-100.0250015258789px, -100.0250015258789px);
      }
    }
    @keyframes kf_el_ISgU0t5CVH_an_kLxXqVD9M {
      0% {
        -webkit-transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
        transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
      }
      100% {
        -webkit-transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(360deg) translate(-100.0250015258789px, -100.0250015258789px);
        transform: translate(100.0250015258789px, 100.0250015258789px)
          rotate(360deg) translate(-100.0250015258789px, -100.0250015258789px);
      }
    }
    @-webkit-keyframes kf_el_kYMKZMP2nP_an_NEANKTKGl {
      0% {
        -webkit-transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
        transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
      }
      100% {
        -webkit-transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(-360deg)
          translate(-100.02499771118164px, -100.00000381469727px);
        transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(-360deg)
          translate(-100.02499771118164px, -100.00000381469727px);
      }
    }
    @keyframes kf_el_kYMKZMP2nP_an_NEANKTKGl {
      0% {
        -webkit-transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
        transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
      }
      100% {
        -webkit-transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(-360deg)
          translate(-100.02499771118164px, -100.00000381469727px);
        transform: translate(100.02499771118164px, 100.00000381469727px)
          rotate(-360deg)
          translate(-100.02499771118164px, -100.00000381469727px);
      }
    }
    @-webkit-keyframes kf_el_JvCQd_StWJ_an_guBR4WYR8 {
      0% {
        -webkit-transform: translate(100.0250015258789px, 100px) rotate(0deg)
          translate(-100.0250015258789px, -100px);
        transform: translate(100.0250015258789px, 100px) rotate(0deg)
          translate(-100.0250015258789px, -100px);
      }
      100% {
        -webkit-transform: translate(100.0250015258789px, 100px) rotate(360deg)
          translate(-100.0250015258789px, -100px);
        transform: translate(100.0250015258789px, 100px) rotate(360deg)
          translate(-100.0250015258789px, -100px);
      }
    }
    @keyframes kf_el_JvCQd_StWJ_an_guBR4WYR8 {
      0% {
        -webkit-transform: translate(100.0250015258789px, 100px) rotate(0deg)
          translate(-100.0250015258789px, -100px);
        transform: translate(100.0250015258789px, 100px) rotate(0deg)
          translate(-100.0250015258789px, -100px);
      }
      100% {
        -webkit-transform: translate(100.0250015258789px, 100px) rotate(360deg)
          translate(-100.0250015258789px, -100px);
        transform: translate(100.0250015258789px, 100px) rotate(360deg)
          translate(-100.0250015258789px, -100px);
      }
    }
    #el__9SDZEX4H * {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
      -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
      animation-timing-function: cubic-bezier(0, 0, 1, 1);
    }
    #el_nDqEFTlzLf {
      stroke: none;
    }
    #el_6LfuXXhGfC {
      fill: transparent;
      stroke: none;
    }
    #el_k2FG40ov16 {
      fill: transparent;
      stroke: none;
    }
    #el_px4oJP_bi8N {
      stroke: none;
    }
    #el_JvCQd_StWJ_an_guBR4WYR8 {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(100.0250015258789px, 100px) rotate(0deg)
        translate(-100.0250015258789px, -100px);
      transform: translate(100.0250015258789px, 100px) rotate(0deg)
        translate(-100.0250015258789px, -100px);
      -webkit-animation-name: kf_el_JvCQd_StWJ_an_guBR4WYR8;
      animation-name: kf_el_JvCQd_StWJ_an_guBR4WYR8;
      -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
      animation-timing-function: cubic-bezier(0, 0, 1, 1);
    }
    #el_kYMKZMP2nP_an_NEANKTKGl {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(100.02499771118164px, 100.00000381469727px)
        rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
      transform: translate(100.02499771118164px, 100.00000381469727px)
        rotate(0deg) translate(-100.02499771118164px, -100.00000381469727px);
      -webkit-animation-name: kf_el_kYMKZMP2nP_an_NEANKTKGl;
      animation-name: kf_el_kYMKZMP2nP_an_NEANKTKGl;
      -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
      animation-timing-function: cubic-bezier(0, 0, 1, 1);
    }
    #el_ISgU0t5CVH_an_kLxXqVD9M {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(100.0250015258789px, 100.0250015258789px)
        rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
      transform: translate(100.0250015258789px, 100.0250015258789px)
        rotate(0deg) translate(-100.0250015258789px, -100.0250015258789px);
      -webkit-animation-name: kf_el_ISgU0t5CVH_an_kLxXqVD9M;
      animation-name: kf_el_ISgU0t5CVH_an_kLxXqVD9M;
      -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
      animation-timing-function: cubic-bezier(0, 0, 1, 1);
    }
    #el_JvCQd_StWJ {
      visibility: hidden;
    }
  </style>
  <defs id="defs30" />
  <g transform="translate(-50.4,-50.4)" id="el_CQe-AVHKNw">
    <g
      data-animator-type="1"
      data-animator-group="true"
      id="el_JvCQd_StWJ_an_guBR4WYR8"
    />
    <g
      data-animator-type="1"
      data-animator-group="true"
      id="el_kYMKZMP2nP_an_NEANKTKGl"
    >
      <g id="el_kYMKZMP2nP">
        <g id="el_lroFLbTBk_">
          <g id="el_gKICPvujVW">
            <path
              id="el_nDqEFTlzLf"
              d="m 143.45,75.75 -12.15,6.95 -0.05,-0.05 q 4.4,7.8 4.4,17.35 0,14.75 -10.45,25.2 -1.3,1.3 -2.65,2.45 h 0.05 l 7.25,8.7 1.75,2 q 1.8,-1.55 3.5,-3.25 14.55,-14.55 14.55,-35.1 0,-13.35 -6.2,-24.25 m -23,-19.2 0.75,-1.55 q -9.7,-4.55 -21.2,-4.6 -9,0 -16.85,2.8 -10.1,3.6 -18.2,11.7 v 0.05 q -8.8,8.8 -12.25,19.85 -2.3,7.2 -2.3,15.2 0.05,12.8 5.7,23.3 l 1.6,-0.85 q 0.25,-0.15 0.55,-0.25 1.75,-1 3.55,-1.95 2.476953,-1.32734 4.95,-2.65 0.206836,-0.11133 0.4,-0.25 0.178711,-0.0582 0.3,-0.15 l 0.95,-0.5 q -4.05,-7.55 -4,-16.7 0,-5.8 1.65,-11 v 0.05 q 2.5,-7.9 8.8,-14.25 h 0.05 q 5.75,-5.8 12.95,-8.4 5.65,-2 12.15,-2 8.25,-0.05 15.2,3.25 l 3,-6.35 q 1.1,-2.35 2.25,-4.75 z"
            />
            <path
              id="el_6LfuXXhGfC"
              d="m 121.2,55 -0.75,1.55 q -1.15,2.4 -2.25,4.75 l -3,6.35 q 5.4,2.55 10,7.15 3.65,3.65 6.05,7.85 l 0.05,0.05 12.15,-6.95 q -3.3,-5.8 -8.35,-10.85 -6.4,-6.4 -13.9,-9.9 m -53.75,62.2 q -0.121289,0.0918 -0.3,0.15 -0.193164,0.13867 -0.4,0.25 -2.473047,1.32266 -4.95,2.65 -1.8,0.95 -3.55,1.95 -0.3,0.1 -0.55,0.25 l -1.6,0.85 q 3.35,6.35 8.85,11.8 l 0.05,0.05 q 14.5,14.45 35,14.45 18.1,-0.05 31.55,-11.2 l -1.7,-2.05 -7.25,-8.7 h -0.05 q -9.6,8 -22.55,7.95 -14.7,0 -25.15,-10.4 -4,-3.95 -6.4,-8.5 z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      data-animator-type="1"
      data-animator-group="true"
      id="el_ISgU0t5CVH_an_kLxXqVD9M"
    >
      <g id="el_ISgU0t5CVH">
        <g id="el_AfjaWJRWSX">
          <g id="el_vr6aB36p4S">
            <path
              id="el_k2FG40ov16"
              d="m 104.4,82.45 q 4.7,1.15 8.45,4.85 5.25,5.25 5.25,12.75 0,7.45 -5.2,12.8 -0.05,0 -0.05,0.05 -3.75,3.6 -8.45,4.75 l 1.15,5.2 0.55,2.1 q 0.5,2.35 1.05,4.75 0.05,0.2 0.1,0.4 l 0.25,1.2 h 0.05 q 8.5,-1.9 15.2,-8.5 l 0.05,-0.05 q 9.3,-9.5 9.3,-22.7 0,-13.3 -9.35,-22.65 -6.65,-6.65 -15.2,-8.6 l -1.7,7.3 q -0.55,2.35 -1.1,4.75 -0.05,0.15 -0.1,0.4 l -0.3,1.2 z"
            />
            <path
              id="el_px4oJP_bi8N"
              d="m 87.2,87.3 q 5.35,-5.35 12.85,-5.35 2.25,0 4.3,0.5 l 0.3,-1.2 q 0.05,-0.25 0.1,-0.4 0.55,-2.4 1.1,-4.75 l 1.7,-7.3 q -3.55,-0.85 -7.5,-0.85 -13.3,0 -22.75,9.45 -9.35,9.35 -9.35,22.65 0,13.2 9.35,22.7 l 0.05,0.05 q 9.4,9.3 22.7,9.3 3.9,0 7.45,-0.8 l -0.25,-1.2 q -0.05,-0.2 -0.1,-0.4 -0.55,-2.4 -1.05,-4.75 h -0.05 l -0.5,-2.1 -1.15,-5.2 q -2.1,0.45 -4.35,0.45 -7.5,0 -12.8,-5.2 l -0.05,-0.05 q -5.25,-5.35 -5.25,-12.8 0,-7.5 5.25,-12.75 z"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
